const ACTION_TYPES = require('reducers/cookies').ACTION_TYPES;
const cookieUtils = require('utils/Cookies');

const cookieHandler = store => next => action => {
    let result;
    switch (action.type) {
        case ACTION_TYPES.SET_COOKIE:
            cookieUtils.write(
                action.name,
                action.value,
                action.days,
                action.top
            );
            result = next(action);
            break;
        case ACTION_TYPES.DELETE_COOKIE:
            cookieUtils.delete(action.cookie);
            result = next(action);
            break;
        default:
            result = next(action);
            break;
    }

    return result;
};

module.exports = cookieHandler;
